import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import { TextFormFieldRow } from '@rd-web-markets/shared/dist/util/form/TextFormFieldRow';
import { useTranslation } from 'react-i18next';

const AllowedCharactersForm = ({ loading, onSubmit }) => {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    invalid_character: '',
    replacement_character: '',
    description: ''
  });

  const allRequiredFieldsFilled = form.invalid_character.trim() !== '';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!allRequiredFieldsFilled) return;
    await onSubmit(form);
    setForm({ invalid_character: '', replacement_character: '', description: '' });
  };

  return (
    <div className="p-3 border rounded mb-4 bg-light">
      <Row>
        <Col md={3}>
          <TextFormFieldRow
            fieldName="invalid_character"
            label="invalid_character"
            value={form.invalid_character}
            onChange={handleChange}
            required
            dataTestId="invalid_character_input"
            labelColSpan={12}
          />
        </Col>
        <Col md={3}>
          <TextFormFieldRow
            fieldName="replacement_character"
            label="replacement_character"
            value={form.replacement_character}
            onChange={handleChange}
            placeholder={t('replacement_character_optional')}
            dataTestId="replacement_character_input"
            labelColSpan={12}
          />
        </Col>
        <Col md={6}>
          <TextFormFieldRow
            fieldName="description"
            label="description"
            value={form.description}
            onChange={handleChange}
            dataTestId="description_input"
            labelColSpan={12}
          />
        </Col>
      </Row>
      <div className="d-flex justify-content-end">
        <SaveButton
          onClick={handleSubmit}
          disabled={!allRequiredFieldsFilled || loading}
          text={loading ? t('creating') : t('create')}
        />
      </div>
    </div>
  );
};

export default AllowedCharactersForm;
